import React, { useState } from 'react';
import './Services.css';

function Services() {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      title: 'Brand & Event Hospitality Consulting',
      description: 'We advise and support brands, federations and rights-holders in the design and delivery of premium hospitality across sporting, business, cultural events.',
      subtitle: 'Our role bridges strategic intent and on-the-ground execution — ensuring guest experiences are commercially aligned, operationally sound and culturally resonant.',
      services: [
        'Guest experience strategy and hospitality concept design',
        'Brand and sponsorship integration within live environments',
        'VIP journey design and hosting standards',
        'Operational planning and on-site supervision',
        'Stakeholder alignment and hosting team coordination',
        'End-to-end delivery of premium hospitality experiences'
      ]
    },
    // {
    //   title: 'Private Office Services',
    //   description: 'We act as a trusted extension of select individuals and families, providing discreet counsel and seamless execution across lifestyle, travel and experiential priorities.',
    //   subtitle: 'Our role is to simplify complexity — managing relationships, curating access and orchestrating experiences so that private lives operate with clarity.',
    //   services: [
    //     'Lifestyle oversight and personal project coordination',
    //     'Bespoke travel planning and global concierge services',
    //     'Curated access to sporting, cultural and entertainment events',
    //     'Relationship management with brands, venues and exclusive communities',
    //     'Private hosting and entertainment strategy',
    //     'Family office liaison and special assignments'
    //   ]
    // }
  ];

  return (
    <div className="services">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Services</span>
          <h2 className="section-title">What We Offer</h2>
        </div>

        {/* Restore tabs when Private Office Services is re-enabled
        <div className="services-tabs">
          {services.map((service, index) => (
            <button
              key={index}
              className={`service-tab ${activeService === index ? 'active' : ''}`}
              onClick={() => setActiveService(index)}
            >
              {service.title}
            </button>
          ))}
        </div>
        */}

        <div className="service-content" key={activeService}>
          <div className="service-main">
            <h3>{services[activeService].title}</h3>
            <p className="service-description">{services[activeService].description}</p>
            <p className="service-subtitle">{services[activeService].subtitle}</p>
            
            <div className="service-list">
              <p className="service-list-title">Services includes:</p>
              <ul>
                {services[activeService].services.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
